import React from "react";
import { IonFooter, IonRow, IonCol, IonButton } from "@ionic/react";
import { concatUrlId } from "../../common/constants";
import { DOWNLOAD_PDF_URL } from "../../common/constants";

/**
 * Footer component for FlyDay
 */
export const FlyDayFooter = ({
  canDownloadPdf,
  day,
  startDisabled,
  onStart,
  onDownloadCSV
}) => {
  return (
    <IonFooter>
      <IonRow>
        <IonCol sizeXs={canDownloadPdf ? '6' : '12'} sizeMd="4" offsetMd={canDownloadPdf ? '0' : '4'}>
          {canDownloadPdf ? (
            <IonButton
              expand="full"
              href={concatUrlId(DOWNLOAD_PDF_URL, day.replace(/\./g, "-"))}
              target="_blank"
            >
              Stáhnout Pdf
            </IonButton>
          ) : (
            <IonButton expand="full" disabled={startDisabled} onClick={onStart}>
              Start
            </IonButton>
          )}
        </IonCol>
        {canDownloadPdf && (
          <IonCol sizeXs="6" sizeMd="4" offsetMd="4">
            <IonButton expand="full" onClick={onDownloadCSV}>
              Stáhnout CSV
            </IonButton>
          </IonCol>
        )}
      </IonRow>
    </IonFooter>
  );
};

